module.exports = __webpack_public_path__ + "img/ypdc3.8a44730c.jpg";